(() => {
  const periods = [...(document.querySelectorAll?.('[data-ua-offer-period]') || [])];
  if (periods.length) {
    let periodTimer;
    const updatePeriods = () => {
      window.clearTimeout(periodTimer);
      const now = Math.floor(Date.now() / 1000);
      let nextBoundary = Infinity;
      for (const offer of periods) {
        const start = Number(offer.dataset.startsAt);
        const end = Number(offer.dataset.endsAt);
        const valid = Number.isFinite(start) && Number.isFinite(end) && start > 0 && end > start;
        offer.hidden = !valid || (offer.hasAttribute('data-ua-offer-archive') ? now < end : !(start <= now && now < end));
        if (valid) {
          if (start > now) nextBoundary = Math.min(nextBoundary, start);
          if (end > now) nextBoundary = Math.min(nextBoundary, end);
        }
      }
      const archiveEmpty = document.querySelector('[data-ua-archive-empty]');
      if (archiveEmpty) archiveEmpty.hidden = periods.some((offer) => offer.hasAttribute('data-ua-offer-archive') && !offer.hidden);
      for (const group of document.querySelectorAll('[data-ua-offers]')) {
        const empty = group.querySelector('[data-ua-offers-empty]');
        if (empty) empty.hidden = [...group.querySelectorAll('[data-ua-offer-period]')].some((offer) => !offer.hidden);
      }
      if (nextBoundary !== Infinity) {
        periodTimer = window.setTimeout(updatePeriods, Math.min((nextBoundary - now) * 1000, 2147483647));
      }
    };
    updatePeriods();
    document.addEventListener('visibilitychange', updatePeriods);
  }

  const banner = document.querySelector('[data-ua-promo-banner]');
  if (banner) {
    let expiryTimer;
    const updateBanner = () => {
      window.clearTimeout(expiryTimer);
      const now = Math.floor(Date.now() / 1000);
      const start = Number(banner.dataset.startsAt || 0);
      const end = Number(banner.dataset.endsAt || 0);
      banner.hidden = !(start && end && start <= now && now < end);
      if (!banner.hidden) {
        expiryTimer = window.setTimeout(updateBanner, Math.min((end - now) * 1000, 2147483647));
      }
    };
    updateBanner();
    document.addEventListener('visibilitychange', updateBanner);
  }

  const dialog = document.querySelector('[data-ua-promo-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const closeButton = dialog.querySelector('[data-ua-promo-close]');
  const start = Number(dialog.dataset.startsAt || 0);
  const end = Number(dialog.dataset.endsAt || 0);
  const campaign = `${start}-${end}`;
  const storageKey = `ua-promotion-dismissed:${campaign}`;
  let interacted = false;
  let timer;
  let opener = null;

  const offerIsCurrent = () => {
    const now = Math.floor(Date.now() / 1000);
    return Boolean(start && end && start <= now && now < end);
  };

  const close = () => {
    if (dialog.open) dialog.close();
  };

  // An already-open dialog must not keep advertising an expired offer.
  let dialogExpiryTimer;
  const updateDialogPeriod = () => {
    window.clearTimeout(dialogExpiryTimer);
    if (!offerIsCurrent()) {
      close();
      return;
    }
    const now = Math.floor(Date.now() / 1000);
    dialogExpiryTimer = window.setTimeout(updateDialogPeriod, Math.min((end - now) * 1000, 2147483647));
  };
  updateDialogPeriod();
  document.addEventListener('visibilitychange', updateDialogPeriod);

  const show = (focusTarget = closeButton) => {
    if (!offerIsCurrent() || dialog.open) return;
    opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    dialog.showModal();
    focusTarget?.focus();
    try { sessionStorage.setItem(storageKey, 'shown'); } catch { /* Storage may be blocked. */ }
  };

  const maybeShow = () => {
    if (!interacted || !banner) return;
    try { if (sessionStorage.getItem(storageKey)) return; } catch { /* Signup remains available without storage. */ }
    show();
  };

  const onInteraction = () => {
    interacted = true;
    maybeShow();
  };

  document.addEventListener('pointerdown', onInteraction, { once: true, passive: true });
  document.addEventListener('keydown', onInteraction, { once: true });
  document.addEventListener('touchstart', onInteraction, { once: true, passive: true });
  timer = window.setTimeout(maybeShow, 10000);

  closeButton?.addEventListener('click', close);
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) close();
  });
  dialog.addEventListener('close', () => {
    window.clearTimeout(timer);
    opener?.focus?.({ preventScroll: true });
    opener = null;
  });

  document.querySelector('[data-ua-promo-open]')?.addEventListener('click', () => show());
  const feedback = dialog.querySelector('[data-ua-promo-signup-feedback]');
  if (feedback?.dataset.state && window.location?.hash === '#ua-promo-newsletter') show(feedback);
})();
